import React, { useContext, useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CustomerContext } from "../CashierHomepage";
import { CustomerIdContext } from "../../context/CustomerIdProvider";
import CashierApi from "../../utility/CashierApi";
import AddIcon from "@mui/icons-material/Add";

function DraftCartItem() {
  const { createData } = CashierApi();
  const queryClient = useQueryClient();
  const { newCartData, setUpdateResumeStatus } = useContext(CustomerContext);
  const { selectedCustomerId } = useContext(CustomerIdContext);

  const [data, setData] = useState({});

  const mutation = useMutation({
    mutationFn: (data) => createData("orders/store", data),
    retry: false,
    onSuccess: () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      queryClient.invalidateQueries("cart");
    },
  });

  const handleDraft = () => {
    mutation.mutate(data);
    setUpdateResumeStatus(false);
  };

  useEffect(() => {
    setData({
      customer_id: selectedCustomerId,
      status: "draft",
      carts: newCartData,
    });
  }, [newCartData, selectedCustomerId]);

  return (
    <button className="p-2 text-sm rounded-lg text-white flex justify-center items-center">
      {" "}
      <AddIcon
        sx={{ fontSize: "30px" }}
        className="cursor-pointer"
        onClick={() => handleDraft()}
      />
    </button>
  );
}

export default DraftCartItem;
